import React from 'react';
import { isEmpty } from 'lodash';
import {
  Typography,
  MenuItem,
  ListItemText,
  FormControl,
  FormHelperText,
  Select,
} from '@mui/material';

import { PostStatus, PostStatusType } from '../../../../../Utils/Types/PostStatuses';

interface PostStatusSelectProps {
  value: PostStatusType;
  statuses: PostStatus[];
  onChange?: (value: string) => void;
  error: any;
}

function PostStatusSelect({ value, statuses, onChange, error }: PostStatusSelectProps) {
  if (isEmpty(statuses)) {
    return null;
  }

  const status = statuses.find((statusItem: any) => statusItem.keyword === value);

  return (
    <FormControl variant="outlined" fullWidth error={error}>
      <Select
        id="status-select"
        value={value}
        onChange={(event: any) => onChange && onChange(event.target.value)}
        renderValue={() => (
          <ListItemText primary={<Typography variant="body1">{status?.title}</Typography>} />
        )}
      >
        {statuses.map((item: any) => (
          <MenuItem key={item.keyword} value={item.keyword}>
            <ListItemText primary={<Typography variant="body1">{item.title}</Typography>} />
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{error}</FormHelperText>
    </FormControl>
  );
}

export default PostStatusSelect;
